import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.ready)
    ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
        default: _withCtx(({ Component, route }) => [
          (_openBlock(), _createBlock(_KeepAlive, { include: _ctx.keepAliveInclude }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: route.path
            }))
          ], 1032, ["include"]))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}